import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMutedIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M7.53873 12.0006C7.53873 12.1822 7.54568 12.3656 7.55824 12.5488C7.58747 12.9751 7.64705 13.3994 7.71983 13.7928C7.91961 14.8729 8.78346 15.7737 9.93408 15.9282C10.2186 15.9663 10.5499 15.9991 10.9401 16.023C11.8706 16.0798 12.7115 16.5706 13.2126 17.3124C13.4089 17.6029 13.6163 17.8865 13.8308 18.1555C14.0707 18.4565 14.3438 18.6393 14.6199 18.7209M16.3681 17.0393C16.4205 15.7899 16.4619 14.1295 16.4619 12.0006C16.4619 9.80566 16.4179 8.10856 16.3631 6.84666C16.2976 5.33478 14.7948 4.63642 13.8308 5.84581C13.6163 6.11492 13.4089 6.3985 13.2126 6.6891C12.7115 7.43088 11.8706 7.92159 10.9401 7.97841C10.5499 8.00226 10.2186 8.03502 9.93408 8.07324C9.21225 8.17014 8.60329 8.56075 8.20034 9.10508",
		stroke: "currentColor",
		strokeWidth: 1.42857,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M4 4C9.49545 11.0395 12.8098 14.3156 20.0002 20",
		stroke: "currentColor",
		strokeWidth: 1.42857,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgMutedIcon;
